import { Box, Typography, Container, Grid, Card, CardContent, CardMedia, Chip, Button } from '@mui/material';
import { motion } from 'framer-motion';
import { CalendarToday, Visibility } from '@mui/icons-material';

const Insights = () => {
  const articles = [
    {
      title: 'The Future of Direct Executive Access',
      excerpt: 'How eliminating gatekeepers is transforming business communication...',
      date: 'March 15, 2025',
      category: 'Leadership',
      image: '/images/insight1.jpg',
      readTime: '5 min read',
    },
    {
      title: 'Global Business Trends for 2026',
      excerpt: 'Strategic insights on emerging markets and opportunities...',
      date: 'February 28, 2025',
      category: 'Strategy',
      image: '/images/insight2.jpg',
      readTime: '4 min read',
    },
    {
      title: 'Building Trust Through Transparency',
      excerpt: 'Why direct communication builds stronger business relationships...',
      date: 'January 10, 2025',
      category: 'Leadership',
      image: '/images/insight3.jpg',
      readTime: '6 min read',
    },
  ];

  return (
    <Box sx={{ py: 15, background: '#0B0B0B' }}>
      <Container maxWidth="lg">
        <Typography
          variant="subtitle1"
          sx={{ color: '#C8A96B', letterSpacing: 4, mb: 2, textAlign: 'center' }}
        >
          EXECUTIVE INSIGHTS
        </Typography>

        <Typography
          variant="h2"
          sx={{
            textAlign: 'center',
            mb: 4,
            fontSize: { xs: '2rem', md: '3.5rem' },
          }}
        >
          Thoughts on Leadership
        </Typography>

        <Typography
          sx={{
            textAlign: 'center',
            maxWidth: '700px',
            mx: 'auto',
            color: '#ccc',
            mb: 8,
          }}
        >
          Business insights, leadership advice, and global commentary from John Asfar.
        </Typography>

        <Grid container spacing={4}>
          {articles.map((article, index) => (
            <Grid item xs={12} md={4} key={index}>
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Card
                  sx={{
                    background: '#111',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    transition: 'all 0.3s',
                    '&:hover': {
                      transform: 'translateY(-10px)',
                      boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
                    },
                  }}
                >
                  <CardMedia
                    component="img"
                    height="200"
                    image={article.image}
                    alt={article.title}
                    sx={{ objectFit: 'cover' }}
                  />
                  <CardContent sx={{ flexGrow: 1, p: 3 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
                      <Chip
                        label={article.category}
                        size="small"
                        sx={{
                          background: 'rgba(200,169,107,0.2)',
                          color: '#C8A96B',
                        }}
                      />
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                        <CalendarToday sx={{ fontSize: 14, color: '#666' }} />
                        <Typography variant="caption" sx={{ color: '#666' }}>
                          {article.date}
                        </Typography>
                      </Box>
                    </Box>
                    <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                      {article.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#999', mb: 2 }}>
                      {article.excerpt}
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Typography variant="caption" sx={{ color: '#666' }}>
                        {article.readTime}
                      </Typography>
                      <Button
                        size="small"
                        sx={{
                          color: '#C8A96B',
                          '&:hover': { background: 'rgba(200,169,107,0.1)' },
                        }}
                      >
                        Read More →
                      </Button>
                    </Box>
                  </CardContent>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Insights;